// extracted by mini-css-extract-plugin
export default {"tags":"GameTags_tags--I0c","tag":"GameTags_tag--lSp","iconWrapper":"GameTags_iconWrapper--_kp"};